import React from 'react';
import PropTypes from 'prop-types';

import tabBarStyles from '../TabBar/styles/styles.module.scss';
import * as styles from './styles/styles.module.scss';

const IconTabBar = ({ text, tabs, handler, activeTab }) => {
  const renderLinkItem = item => {
    const { name, showIcon, iconPath } = item;
    let content;
    if (showIcon) {
      content = <img alt={name} src={iconPath} />;
    } else {
      content = text[name];
    }
    return <span className={showIcon ? styles.tabIcon : ''}>{content}</span>;
  };

  const getGroupedTabs = tabs => {
    const grouped = {};
    let tabKey = -1;
    tabs.map(item => {
      if (!item.showTab) {
        return;
      }
      tabKey = item.tab || tabKey + 1;
      if (!grouped[tabKey]) {
        grouped[tabKey] = [];
      }
      return grouped[tabKey].push(renderLinkItem(item));
    });
    return grouped;
  };

  const renderLink = (item, index) => {
    return (
      <div
        key={index}
        tabIndex="0"
        role="tab"
        className={`${styles.tab} ${index == activeTab ? styles.active : ''}`}
        onClick={() => handler(index)}
        onKeyDown={() => handler(index)}
      >
        {item}
      </div>
    );
  };

  const groupedTabs = getGroupedTabs(tabs);
  return <div className={`${styles.tabBar} `}>{Object.keys(groupedTabs).map((item, index) => renderLink(groupedTabs[item], index))}</div>;
};

IconTabBar.defaultProps = {
  handler: () => {},
  activeTab: 0
};

IconTabBar.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({ content: PropTypes.element })).isRequired,
  activeTab: PropTypes.number,
  handler: PropTypes.func
};

export default IconTabBar;
